'use client';

import { useUI } from '@/store';
import { useAppDispatch } from '@/store/hooks';
import { closeModal, openModal } from '@/store/slices/ui.slice';
import { useModalState } from './useModalState';

/**
 * Composes all layout modal states and handlers.
 */
export const useLayoutModals = () => {
  const dispatch = useAppDispatch();
  const { modals } = useUI();

  const deposit = {
    isOpen: modals.deposit,
    onClose: () => dispatch(closeModal('deposit')),
    open: () => dispatch(openModal('deposit')),
  };
  const howItWorksState = useModalState(false);
  const howItWorks = {
    isOpen: howItWorksState.isOpen,
    onClose: howItWorksState.close,
    open: howItWorksState.open,
  };

  const referral = {
    isOpen: modals.referral,
    onClose: () => dispatch(closeModal('referral')),
    open: () => dispatch(openModal('referral')),
  };

  const auth = {
    isOpen: modals.signIn,
    onClose: () => dispatch(closeModal('signIn')),
    open: () => dispatch(openModal('signIn')),
  };

  return {
    auth,
    deposit,
    howItWorks,
    referral,
  };
};
